import React, { useEffect } from 'react'
import ListComments from '../Utils/ListComments'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice'
import { useParams } from 'react-router-dom'
import { getAllCommentsOfPostAPI, getDataWithId } from '../../RTK/Slice/Extract/ExtractPageWithIdSlice'

const ExtractPagePostCommentsWithID = () => {

  // For Get Token
  const token = useSelector(getToken) ; 

  // For Dispatch Action
  const dispatch = useDispatch() ; 

  // For Get User Token 
  const activeToken = useSelector(getActiveToken) ; 

  // For Get Params Post Id
  const {postId} = useParams() ; 

  // For Get Comments
  useEffect(()=>{
    dispatch(getAllCommentsOfPostAPI({token , userToken : activeToken , postId}))
  } , [postId , token]) ;

  // For Access Comments 
  const {comments , statusOfComments} = useSelector(getDataWithId) ;

  return (
    <div>
        <ListComments comments={comments} statusOfComments={statusOfComments}  />
    </div>
  )
}

export default ExtractPagePostCommentsWithID
